// JS
import '../../custom/js/index';
import '../../custom/js/components/modal';

// Base SCSS
import '../../custom/scss/base.scss';
import '../../custom/scss/layout.scss';

import '../../custom/js/components/modal/video-modal.js';

// Components SCSS
import '../../custom/scss/components/breadcrumb/breadcrumb.scss';
import '../../custom/scss/components/hero/hero.scss';
import '../../custom/scss/components/benefits/benefits.scss';
import '../../custom/scss/components/benefits/benefit-card.scss';
import '../../custom/scss/components/national-stats/national-stats.scss';
import '../../custom/scss/components/roles/roles.scss';
import '../../custom/scss/components/video/video-story-card.scss';
import '../../custom/scss/components/search/office-search.scss';
import '../../custom/scss/components/modal/modal.scss';
import '../../custom/scss/components/hero/video-hero.scss';

// import Vue App
import Vue from 'vue';
import VueApp from '../../custom/vue/custom-apps/office-search';
import App from '../../custom/vue/custom-apps/containers/office-search.vue';

// connect vue component and init app
Vue.component('app', App);
VueApp.$mount('#search-app');